import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import styles from './Modal.module.scss';

const ModalAction = (props) => {
  const { primaryTitle, primaryAction, primaryDisabled, primaryTooltip, secondaryTitle, secondaryAction, secondaryDisabled, secondaryTooltip } = props;

  const displayPrimaryButton = useMemo(
    () => primaryTitle && (
      <Button onClick={primaryAction} disabled={primaryDisabled} tooltip={primaryTooltip}>
        {primaryTitle}
      </Button>
    ),
    [primaryTitle, primaryAction, primaryDisabled, primaryTooltip]
  );

  const displaySecondaryButton = useMemo(
    () => secondaryTitle && (
      <Button theme="navy" onClick={secondaryAction} disabled={secondaryDisabled} tooltip={secondaryTooltip}>
        {secondaryTitle}
      </Button>
    ),
    [secondaryTitle, secondaryAction, secondaryDisabled, secondaryTooltip]
  );

  return (
    <div className={styles.modalAction} {...props}>
      {displaySecondaryButton}
      {displayPrimaryButton}
    </div>
  )
};

ModalAction.propTypes = {
  primaryTitle: PropTypes.string,
  secondaryTitle: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryTooltip: PropTypes.string,
  secondaryAction: PropTypes.func,
  primaryDisabled: PropTypes.bool,
  secondaryDisabled: PropTypes.bool,
  secondaryTooltip: PropTypes.string
}

ModalAction.defaultProps = {
  primaryTitle: null,
  secondaryTitle: null,
  primaryAction: null,
  primaryTooltip: null,
  secondaryAction: null,
  primaryDisabled: false,
  secondaryDisabled: false,
  secondaryTooltip: null
}

export default memo(ModalAction);
